var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"reduce-row-gaps",attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',[_vm._v("Admin Dashboard")]),_c('v-card-text',[_c('v-row')],1),_c('v-card-actions')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }